/**
 * Terms of Service Version Configuration
 *
 * This file maintains the current version of the Terms of Service
 * and provides helper functions for version comparison.
 */

// The latest version of the Terms of Service
export const LATEST_TOS_VERSION = "1.0"

// TOS version history with dates
export const TOS_VERSION_HISTORY = [
  { version: "1.0", releaseDate: new Date("2024-06-01"), required: true },
]

/**
 * Check if a user needs to re-accept the Terms of Service
 *
 * @param userVersion The version the user has accepted, if any
 * @returns boolean indicating if the user needs to accept new terms
 */
export function needsToAcceptNewTerms(userVersion: string | null): boolean {
  if (!userVersion) {
    return true
  }

  return userVersion !== LATEST_TOS_VERSION
}

/**
 * Get information about the latest Terms of Service version
 *
 * @returns Object with version and release date
 */
export function getLatestTosVersion() {
  return {
    version: LATEST_TOS_VERSION,
    releaseDate: TOS_VERSION_HISTORY[0].releaseDate
  }
}
